import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import AuctionItem from '@Components/Auction/AuctionItem';
import { AuctionFragment, MyAuctionFragment } from '@Graphql/graphqlTypes.generated';
import { getUserData } from '@Store/auth/auth.selector';
import { UserData } from '@Store/auth/auth.types';

import styles from './AuctionsList.module.scss';

type AuctionGenericFragment = MyAuctionFragment | AuctionFragment;

export interface AuctionsListProps {
  auctions: AuctionGenericFragment[];
  onClick?: () => void;
}

const AuctionsList: FunctionComponent<AuctionsListProps> = ({ onClick, auctions = [] }) => {
  const user: UserData = useSelector(getUserData);

  const companyId = user.item?.info.activeCompany.company.id;

  const isMyAuction = (auction: AuctionGenericFragment): auction is MyAuctionFragment =>
    auction.__typename === 'MyAuctionNode';

  return (
    <div className={styles.container}>
      {auctions.map(auction => {
        const auctionItem = isMyAuction(auction) ? auction.auction : auction;
        const isDeletable = isMyAuction(auction) ? auction.isDeletable : false;

        return (
          <AuctionItem
            onClick={onClick}
            key={auction.id}
            auction={auctionItem}
            isOwner={auctionItem.company.id === companyId}
            isDeletable={isDeletable}
          />
        );
      })}
    </div>
  );
};

export default AuctionsList;
